import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useDarkMode } from '../../context/DarkModeContext';
export const ImageCarousel = ({
  images
}: {
  images: string[];
}) => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const {
    darkMode
  } = useDarkMode();
  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };
  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };
  if (!images || images.length === 0) return null;
  return <div className="relative" data-id="element-6490" data-mp="3qnax40q2bb0l">
      <h3 className={`text-xl font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-6491" data-mp="3qmhyjn19brtj">
        My Aesthetic
      </h3>
      <div className="relative group" data-id="element-6492" data-mp="1rctaimr86bny">
        <div ref={carouselRef} className="flex overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory gap-4" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-6493" data-mp="1w8qfxy0y9xly">
          {images.map((image, index) => <div key={index} className="flex-shrink-0 w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.333%-12px)] h-48 rounded-lg overflow-hidden snap-start" data-id="element-6494" data-mp="qk20h0g3y6ui" data-mpi={index}>
              <img src={image} alt={`Author aesthetic ${index + 1}`} className="w-full h-full object-cover" data-id="element-6495" data-mp="1ic9fjwfytb6s" />
            </div>)}
        </div>
        {images.length > 1 && <>
            <button onClick={scrollLeft} className={`absolute left-0 top-1/2 -translate-y-1/2 rounded-full p-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity ${darkMode ? 'bg-gray-800/80 text-white hover:bg-gray-700' : 'bg-white/80 text-gray-700 hover:bg-white'}`} aria-label="Scroll left" data-id="element-6496" data-mp="19d5u4ltbsjp4">
              <ChevronLeftIcon className="h-6 w-6" data-id="element-6497" data-mp="3qkfl5sbht9ih" />
            </button>
            <button onClick={scrollRight} className={`absolute right-0 top-1/2 -translate-y-1/2 rounded-full p-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity ${darkMode ? 'bg-gray-800/80 text-white hover:bg-gray-700' : 'bg-white/80 text-gray-700 hover:bg-white'}`} aria-label="Scroll right" data-id="element-6498" data-mp="3vizbs61179h6">
              <ChevronRightIcon className="h-6 w-6" data-id="element-6499" data-mp="37r1zkdto6ffj" />
            </button>
          </>}
      </div>
    </div>;
};